document.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector("[data-moke-nav]");
  if (nav) {
    const onScroll = () => {
      if (window.scrollY > 40) {
        nav.classList.add("moke-nav--scrolled");
      } else {
        nav.classList.remove("moke-nav--scrolled");
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (event) => {
      const targetId = anchor.getAttribute("href").slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
});
